/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './service.defs.js'
export * as $defs from './service.defs.js'
